// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__33UIl","footer":"ModalFilter_footer__1PRjI"};